import {
  newRuntimeActivator,
  type RuntimeActivator
} from "@common-core/web-component-runtime/runtime";
import {type Environment} from "./Environment";
import {runtimes} from "./runtimes";
import {environments} from "./environments";

export const activateRuntime: RuntimeActivator<Environment> =
  newRuntimeActivator<Environment>({
    runtimes,
    environments
  });
